export default "__VITE_ASSET__71f64865__"